import BaseExternalView from 'registration/js/base/external_view';
import WaitingView from 'registration/js/new/waiting_view';

import services from 'registration/templates/new/services.html';
import serviceComplete from 'registration/templates/new/service_complete.html';
import serviceGettokenMessage from 'registration/templates/base/service_gettoken_message.html';

const ExternalServiceView = BaseExternalView.extend({
    templates: {
        services,
        serviceComplete,
        serviceGettokenMessage
    },
    WaitingView,
});

export default ExternalServiceView;
